import { Injectable } from "@angular/core";

import { ShortNumberService } from "./short-number.service";

@Injectable()
export class DigitLimitingService {
  constructor(private shortNum: ShortNumberService) {}

  transform(value: string | number = "", digits: number = 3): string | null {
    if (Number(value) === 0) {
      return "0";
    }

    const shortNum: string | null = this.getModifiedShortNum(value, digits);

    if (shortNum == null) {
      return shortNum;
    }

    if (parseInt(shortNum[shortNum.length - 1], 10)) {
      return this.appendDecimalPlaces(shortNum, digits);
    }

    return this.appendDecimalsAndSuffix(shortNum, digits);
  }

  private getModifiedShortNum(
    rawNum: string | number,
    digits: number
  ): string | null {
    const shortNum: string | null = this.shortNum.transform(
      rawNum,
      `.0-${digits}`
    );

    if (shortNum != null && shortNum[0] === "0" && shortNum.length > 1) {
      const suffixes: string[] = ["", "k", "M", "B", "T"];
      const newSuffixIndex =
        suffixes.indexOf(shortNum[shortNum.length - 1]) - 1;
      const newSuffix = suffixes[newSuffixIndex];
      return parseFloat(shortNum) * 1000 + newSuffix;
    } else {
      return shortNum;
    }
  }

  private appendDecimalPlaces(shortNum: string, digits: number): string {
    const decimalLengthChange: number = digits - shortNum.length;
    const indexOfDecimal = shortNum.indexOf(".");
    const currentNumberOfDecimals = ~indexOfDecimal
      ? shortNum.length - indexOfDecimal
      : 0;
    const numberOfDecimals = Math.max(
      0,
      currentNumberOfDecimals + decimalLengthChange
    );

    return parseFloat(shortNum).toFixed(numberOfDecimals);
  }

  private appendDecimalsAndSuffix(shortNum: string, digits: number): string {
    const count: string = shortNum.slice(0, shortNum.length - 1);
    return (
      this.appendDecimalPlaces(count, digits) +
      shortNum.slice(shortNum.length - 1)
    );
  }
}
